import { FC } from 'react';
import { Coordinate, Location as LocationT } from '../../types';
import { useLocation } from './service';
import { useIntl } from 'react-intl';

const formatLocationShort = (location: LocationT) =>
  `${
    location.street ? `${location.street} ${location.houseNumber ?? ''}, ` : ''
  }${location.zip ?? ''} ${location.locality}, ${location.country}`;

export interface LocationProps extends Coordinate {}

export const Location: FC<LocationProps> = (coord) => {
  const { location, setRef } = useLocation(coord);
  const { $t } = useIntl();

  return (
    <span ref={(ref) => setRef(ref)}>
      {location
        ? formatLocationShort(location)
        : $t({ id: 'Location.Running' })}
    </span>
  );
};
